import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  OnboardingLegalClientDocument,
  useLegalClientCompleteHeadOnboardingMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useLegalClientCompleteHeadOnboarding = () => {
  const [handle, { loading, error: apolloError }] =
    useLegalClientCompleteHeadOnboardingMutation({
      refetchQueries: [OnboardingLegalClientDocument],
      awaitRefetchQueries: true,
    });

  const error = useError(apolloError);

  const complete = useCallback(
    async (legalId: string, headId: string) => {
      const res = await handle({
        variables: { id: legalId, headId },
      });
      return !!res.data?.legalClientCompleteHeadOnboarding;
    },
    [handle]
  );

  return {
    loading,
    error,
    complete,
  };
};
